import { diContainer } from '../DIContainer';
export class Store {
    static get $store() {
        return diContainer.resolve('store');
    }
    static get $modelsStore() {
        return diContainer.resolve('modelsStore');
    }
    static get(key) {
        return this.$store[key];
    }
    static set(key, value) {
        this.$store[key] = value;
        this.persist(key, value);
    }
    static persist(key, value) {
        const ignored = [
            'isOnline',
            'localConnection',
            'syncStatus',
            'syncOptions',
            'impersonate',
            'trainingMode',
            'tableMode',
            'subscriptionExpired',
            'activeSector',
        ];
        if (!ignored.includes(key)) {
            const appStorage = diContainer.resolve('appStorage');
            appStorage.store().setItem(key, value);
        }
    }
    static setState(state) {
        this.$store.$patch(state);
    }
    static models() {
        return this.$modelsStore;
    }
}
export default Store;
//# sourceMappingURL=Store.js.map